<template>
  <div style="width: 100%; height: 100%">
    <vs-card>
      <b-row class="mb-8">
        <b-col lg="4">
          <b-row v-if="ROLE != 'Company'">
            <b-col cols="3" align-self="center">
              <b-form-group
                style="font-size: small; font-weight: bold"
                :label="'* ' + $t('Customer')"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                color="danger"
                v-model="customer"
                :options="customer_choices"
                size="small"
                label="name"
                v-on:input="getCompletedOrders"
                autocomplete
                ref="selectElement"
                name="customer"
                v-validate="'required'"
              >
              </v-select>

              <span class="text-danger text-sm" v-show="errors.has('customer')">{{
                errors.first("customer")
              }}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <b-row>
            <b-col cols="4" align-self="center">
              <b-form-group
                style="font-size: small; font-weight: bold"
                :label="$t('ReportName')"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                color="danger"
                v-model="reportName"
                :options="reportName_choices"
                size="small"
                label="name"
                autocomplete
                ref="selectElement"
                name="reportName"
                v-validate="'required'"
                @input="runReport"
              >
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('reportName')">{{
                errors.first("reportName")
              }}</span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <ReportListComponent :customer="customerLc" :reportName="reportNameLc" />
    </vs-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import ReportListComponent from "../definitions/ReportListComponent.vue";
export default {
  name: "App",
  components: {
    ReportListComponent,
    vSelect,
  },
  data() {
    return {
      reportName: "",
      reportName_choices: [],
      ROLE: this.$store.state.AppActiveUser.ROLE,
      customer: "",
      customerLc: "",
      reportNameLc: "",
      customer_choices: [],
    };
  },
  computed: {
    companydata: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
  },
  watch: {
    companydata(val) {
      this.getCustomerList();
      return val;
    },
  },
  created() {
    this.getCustomerList();
  },
  methods: {
    runReport() {
      this.customerLc = this.customer;
      this.reportNameLc = this.reportName;
    },
    getCompletedOrders() {
      this.$store
        .dispatch("report/listReportsNameList")
        .then((response) => {
          if (response.success == true) {
            let reportNameList = JSON.parse(response.json);
            this.reportName_choices = Object.keys(reportNameList).map((key) => {
              return {
                value: this.$t(reportNameList[key]),
                name: key,
              };
            });
            vs.notify({
              text: response.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            //    }
          } else {
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    getCustomerList(id, popup) {
      this.customerListOption = [];
      this.customer_choices = [];
      this.customerListOption = this.companydata;
      this.customerListOption.forEach((val, index) => {
        this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
      });
    },
  },
};
</script>

<style>
#chartContainer {
  width: 100%;
  height: 300px;
  margin-top: 20px;
}
</style>
